import React from "react";
import styles from "./MovieOverlay.module.scss";
import { ISectionItem } from "../../_types/interfaces";
import { genresData } from "../../../../constants/structure";
import { movieTitleHandler } from "../../../../utils/helpers";
import { useTranslation } from "react-i18next";
import FilmRating from "../../../../components/icons/searchIcons/fimRating";

interface MovieOverlayProps {
  item: ISectionItem;
  visible?: boolean;
}

const MovieOverlay = ({ item, visible = true }: MovieOverlayProps) => {
  const { t, i18n } = useTranslation();

  if (item.commercial_url) return null;

  const title = movieTitleHandler(i18n.language, item);
  const year = item.release_date?.substring(0, 4);
  const genre = genresData.find((g) => g.id === (item.genre_ids as number[])[0]);
  const rating = item.imdb_rating?.toFixed(1) || item.vote_average?.toFixed(1);

  return (
    <div className={`${styles.overlay} ${visible ? styles.visible : styles.hidden}`}>
      <div className={styles.title}>{title}</div>
      <div className={styles.meta}>
        {year && <span className={styles.year}>{year}</span>}
        {genre && (
          <>
            <span className={styles.dot} />
            <span className={styles.genre}>{t(genre.name)}</span>
          </>
        )}
        {rating && (
          <>
            <span className={styles.dot} />
            <span className={styles.rating}>
              <FilmRating />
              {rating}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default MovieOverlay;
